import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';

const TYPE = 'application/ld+json';
const SELECTOR = `script[type="${TYPE}"]`;

// Structured Data Markup (Schema.org)
export function useStructuredDataHandler() {
  const map = new Map<string, Record<string, any>>();
  const document = inject(DOCUMENT);
  let script: HTMLScriptElement | null;

  const update = () => {
    try {
      if (map.size === 0) {
        // Remove existing structured data scripts if any
        if (script) {
          document.head.removeChild(script);
          script = null;
        }

        const existingScripts = document.querySelectorAll(SELECTOR);
        existingScripts.forEach((script) => document.head.removeChild(script));
        return;
      }

      if (!script) {
        script = document.querySelector(SELECTOR);
      }
      if (!script) {
        script = document.createElement('script');
        script.type = TYPE;
        document.head.appendChild(script);
      }
      if (script) {
        script.text = JSON.stringify(Array.from(map.values()));
      }
    } catch (error) {
      console.error('Failed to set structured data markup:', error);
    }
  };

  return {
    set(key: string, value: Record<string, any>) {
      map.set(key, value);
      update();
    },
    delete(key: string) {
      map.delete(key);
      update();
    }
  };
}
